import Filter, { FilterAttributeKey, MakeFilter, ModelFilter } from '../models/Filter';

interface MakeModelFilter {
  makeModelFilter?: MakeModelFilterCombinations | null;
}

interface MakeModelFilterCombinations {
  combinations: (MakeModelCombination | null)[] | null;
}

interface MakeModelCombination {
  make: string | null;
  model: (string | null)[] | null;
}

class MakeModelFilterBuilder {
  private selectedFilters: Filter[];
  private filter: MakeModelFilter | undefined;

  constructor(selectedFilters: Filter[]) {
    this.selectedFilters = selectedFilters;
  }

  private getCombination(make: string): MakeModelCombination | null | undefined {
    return this.filter?.makeModelFilter?.combinations?.find((comb) => comb?.make === make);
  }

  public build(): MakeModelFilter {
    this.filter = { makeModelFilter: { combinations: [] } };
    this.selectedFilters?.forEach((selectedFilter: Filter) => {
      if (selectedFilter.attributeKey === FilterAttributeKey.MAKE) {
        (selectedFilter as MakeFilter)?.values?.forEach((value) => {
          if (!this.getCombination(value)) {
            this.filter?.makeModelFilter?.combinations?.push({
              make: value,
              model: [],
            });
          }
        });
      } else if (selectedFilter instanceof ModelFilter) {
        const combination = this.getCombination(selectedFilter.getParentKeyValue());
        if (combination) combination.model = selectedFilter.getSelectedValues();
      }
    });
    return this.filter;
  }

  public empty(): boolean {
    return !this.selectedFilters.find((filter) => filter?.attributeKey === FilterAttributeKey.MAKE);
  }
}

export default MakeModelFilterBuilder;
